import { render, staticRenderFns } from "./Epochs.vue?vue&type=template&id=559a1c63"
import script from "./Epochs.vue?vue&type=script&lang=js"
export * from "./Epochs.vue?vue&type=script&lang=js"
import style0 from "./Epochs.vue?vue&type=style&index=0&id=559a1c63&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports